import '@babel/polyfill';

import 'sweetalert2/dist/sweetalert2.min.css';
import './ant-design-vue/dist/antd.css';

import App from './App.vue';
import Moment from 'moment-timezone';
import Vue from 'vue';
import VueMoment from 'vue-momentjs';
import Vuex from 'vuex';
import libs from './libs';
import router from './router';
import store from './stores';

import Antd from './ant-design-vue';

Moment.locale('ko');
Vue.use(VueMoment, Moment);
Vue.prototype.$libs = libs;
Vue.prototype.isPC = screen.width > 575;
Vue.prototype.isBrosaib = location.hostname === 'my.brosaib.com';

Vue.prototype.floors = [
  'B4',
  'B3',
  'B2',
  'B1',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
];

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(Antd);

new Vue({ router, store, render: (h) => h(App) }).$mount('#app');
